package com.evoapps.evoshift.ui.user

import androidx.compose.material3.minimumInteractiveComponentSize
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.combinedClickable
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.filled.History
import androidx.compose.material.icons.filled.DoneAll
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Check
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.parseClockTime
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.availability_copy_previous
import evoshift.composeapp.generated.resources.availability_all_available
import evoshift.composeapp.generated.resources.availability_selected_days
import evoshift.composeapp.generated.resources.availability_multi_select_hint
import evoshift.composeapp.generated.resources.availability_legend_outside
import evoshift.composeapp.generated.resources.availability_hours_incomplete
import evoshift.composeapp.generated.resources.availability_hours_order
import evoshift.composeapp.generated.resources.availability_day_available_mark
import evoshift.composeapp.generated.resources.availability_day_unavailable_mark
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.animation.animateColorAsState
import com.evoapps.evoshift.ui.adaptive.ScrollingRow
import com.evoapps.evoshift.ui.theme.motionTween
import com.evoapps.evoshift.ui.theme.MotionContent
import com.evoapps.evoshift.widgets.rememberStableText
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.domain.model.HoursRange
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import androidx.compose.ui.platform.testTag
import evoshift.composeapp.generated.resources.availability_comment_only_here
import evoshift.composeapp.generated.resources.availability_given_elsewhere
import evoshift.composeapp.generated.resources.availability_goes_to
import evoshift.composeapp.generated.resources.availability_hours_from
import evoshift.composeapp.generated.resources.availability_hours_hint
import evoshift.composeapp.generated.resources.availability_hours_title
import evoshift.composeapp.generated.resources.availability_hours_to
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import androidx.compose.material.icons.filled.Send
import androidx.compose.ui.graphics.vector.ImageVector
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.MonthWeek
import com.evoapps.evoshift.widgets.EvoRadioGroup
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogAction
import androidx.compose.material.icons.filled.ContentCopy
import com.evoapps.evoshift.ui.adaptive.plusHorizontal
import com.evoapps.evoshift.ui.adaptive.CentredBox
import com.evoapps.evoshift.ui.adaptive.ListMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import evoshift.composeapp.generated.resources.availability_pick_day_hint
import evoshift.composeapp.generated.resources.availability_week
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.availability_select_template
import evoshift.composeapp.generated.resources.availability_select_weeks
import com.evoapps.evoshift.ui.util.monthName
import evoshift.composeapp.generated.resources.apply
import evoshift.composeapp.generated.resources.availability_apply_week_template
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.ContentPaste
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.AvailabilitySlot
import com.evoapps.evoshift.domain.model.AvailabilityStatus
import com.evoapps.evoshift.domain.model.DayPreference
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.roster.getDaysInMonth
import com.evoapps.evoshift.viewmodels.AvailabilityFormEvent
import com.evoapps.evoshift.viewmodels.AvailabilityFormViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.availability_add_note_placeholder
import evoshift.composeapp.generated.resources.availability_auto_saving
import evoshift.composeapp.generated.resources.availability_available
import evoshift.composeapp.generated.resources.availability_modify_button
import evoshift.composeapp.generated.resources.availability_my_availability
import evoshift.composeapp.generated.resources.availability_select_preferred_shifts
import evoshift.composeapp.generated.resources.availability_send
import evoshift.composeapp.generated.resources.availability_stats_bar
import evoshift.composeapp.generated.resources.availability_unavailable
import evoshift.composeapp.generated.resources.day_friday
import evoshift.composeapp.generated.resources.day_monday
import evoshift.composeapp.generated.resources.day_saturday
import evoshift.composeapp.generated.resources.day_sunday
import evoshift.composeapp.generated.resources.day_thursday
import evoshift.composeapp.generated.resources.day_tuesday
import evoshift.composeapp.generated.resources.day_wednesday
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.number
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.ui.util.dayAndMonth
import evoshift.composeapp.generated.resources.availability_requested_days
import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AvailabilityFormScreen(
    viewModel: AvailabilityFormViewModel,
    onNavigateBack: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }

    LaunchedEffect(state.success) {
        if (state.success && state.isFilled) {
            onNavigateBack()
        }
    }

    val errorText = (state.error ?: state.info)?.asString()

    LaunchedEffect(errorText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(AvailabilityFormEvent.ClearMessage)
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Color.White,
        topBar = {
            EvoTopBar(
                // SH-89: the month is the bar's (months with a request; App.kt follows it).
                title = stringResource(Res.string.availability_my_availability),
                onBack = onNavigateBack,
                showMonth = true,
                actions = buildList {
                    add(helpAction(HelpPage.AVAILABILITY_FILL))
                    if (!state.isReadOnly) {
                        add(
                            TopBarAction(
                                stringResource(Res.string.availability_send), Icons.Default.Send,
                                { viewModel.onEvent(AvailabilityFormEvent.Submit) },
                                enabled = !state.isSaving, prominent = true, busy = state.isSaving
                            )
                        )
                    }
                }
            )
        }
    ) { padding ->
        if (state.isLoading && state.monthIso.isBlank()) {
            Box(Modifier.fillMaxSize().padding(padding), contentAlignment = Alignment.Center) {
                CircularProgressIndicator(color = DarkGold)
            }
        } else {
            val isExpanded = LocalWindowWidthClass.current.isExpanded
            val maxWidth = if (isExpanded) WideContentMaxWidth else ListMaxWidth
            // SH-130: the calendar reaches the screen's edges (the wheel scrolls it over the empty
            // sides too); the bars above it and the days in it stay within the centred width.
            CentredBox(maxWidth, Modifier.padding(padding)) { margin ->
            Column(modifier = Modifier.fillMaxSize()) {
                // --- Template Action Bar ---
                // SH-165: the month at once: as last month, every day available, a week template.
                if (!state.isReadOnly) {
                    // SH-208: a scrollbar for the mouse while the chips do not fit.
                    ScrollingRow(
                        modifier = Modifier.fillMaxWidth().contentWidth(maxWidth).background(DeepNavy.copy(alpha = 0.05f)),
                        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        ActionChip(
                            icon = Icons.Default.History,
                            label = stringResource(Res.string.availability_copy_previous),
                            onClick = { viewModel.onEvent(AvailabilityFormEvent.CopyPreviousMonth) }
                        )
                        ActionChip(
                            icon = Icons.Default.DoneAll,
                            label = stringResource(Res.string.availability_all_available),
                            onClick = { viewModel.onEvent(AvailabilityFormEvent.SetAllAvailable) }
                        )
                        if (state.availableTemplates.isNotEmpty()) {
                            ActionChip(
                                icon = Icons.Default.ContentPaste,
                                label = stringResource(Res.string.availability_apply_week_template),
                                onClick = { viewModel.onEvent(AvailabilityFormEvent.OpenApplyDialog) }
                            )
                        }
                    }
                }

                // --- Month Selector Bar ---
                Box(
                    modifier = Modifier.fillMaxWidth().contentWidth(maxWidth).background(Color(0xFFF7F2E9))
                        .padding(vertical = 8.dp),
                    contentAlignment = Alignment.Center
                ) {
                    // One form per roster, so one month: no month switching here.
                    val parts = state.monthIso.split("-")
                    val title = if (parts.size == 2) "${monthName(parts[1].toInt())} ${parts[0]}" else state.monthYear
                    Text(title, fontWeight = FontWeight.Bold, color = DeepNavy, modifier = Modifier.padding(vertical = 12.dp))
                }

                // SH-48: the request covers part of the month; the other days are dimmed.
                state.requestedDays?.let { days ->
                    Text(
                        text = stringResource(
                            Res.string.availability_requested_days,
                            days.first,
                            days.last,
                            state.requestDue?.let { dayAndMonth(it) }.orEmpty()
                        ),
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.Bold,
                        color = DeepNavy,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth().contentWidth(maxWidth).background(Color(0xFFF7F2E9)).padding(horizontal = 16.dp).padding(bottom = 8.dp)
                    )
                }

                // SH-135: given once for all workplaces: where it goes, or that it waits to be sent here.
                if (state.givenElsewhere || state.goesTo.size > 1) {
                    Text(
                        text = if (state.givenElsewhere) stringResource(Res.string.availability_given_elsewhere)
                        else stringResource(Res.string.availability_goes_to, state.goesTo.joinToString(", ")),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth().background(com.evoapps.evoshift.ui.AppAppearance.palette.base.noteTint).padding(horizontal = 16.dp, vertical = 8.dp)
                            .testTag(AvailabilityFormTags.SHARED_NOTE)
                    )
                }

                // --- Calendar Grid ---
                val daysInMonth = if (state.monthIso.isNotBlank()) {
                    val parts = state.monthIso.split("-")
                    getDaysInMonth(parts[0].toInt(), parts[1].toInt())
                } else emptyList()

                // --- Stats Bar ---
                Box(
                    modifier = Modifier.fillMaxWidth().contentWidth(maxWidth).background(Color(0xFFFBF4E9)).padding(8.dp),
                    contentAlignment = Alignment.Center
                ) {
                    val availableDays = daysInMonth.filter { state.isRequested(it.day) }.count { date ->
                        val pref = state.days[date.day]
                        (pref?.status
                            ?: AvailabilityStatus.AVAILABLE) == AvailabilityStatus.AVAILABLE
                    }
                    Text(
                        text = stringResource(
                            Res.string.availability_stats_bar,
                            availableDays,
                            availableDays * 8
                        ),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.7f)
                    )
                }

                if (state.isReadOnly && state.canSubmit) {
                    Box(
                        modifier = Modifier.fillMaxWidth().padding(16.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        Button(
                            onClick = { viewModel.onEvent(AvailabilityFormEvent.EnableEditMode) },
                            colors = ButtonDefaults.buttonColors(containerColor = DeepNavy),
                            shape = RoundedCornerShape(8.dp)
                        ) {
                            Icon(
                                Icons.Default.Edit,
                                contentDescription = null,
                                modifier = Modifier.size(18.dp)
                            )
                            Spacer(Modifier.width(8.dp))
                            Text(stringResource(Res.string.availability_modify_button))
                        }
                    }
                }

                // SH-165: what the colours mean; several days at once with a long press.
                AvailabilityLegend(showOutside = state.requestedDays != null, modifier = Modifier.contentWidth(maxWidth))
                if (state.multiSelected.isNotEmpty()) {
                    MultiSelectBar(
                        count = state.multiSelected.size,
                        onSet = { viewModel.onEvent(AvailabilityFormEvent.SetStatusForSelected(it)) },
                        onCancel = { viewModel.onEvent(AvailabilityFormEvent.ClearMultiSelect) },
                        modifier = Modifier.contentWidth(maxWidth)
                    )
                } else if (!state.isReadOnly) {
                    Text(
                        stringResource(Res.string.availability_multi_select_hint),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Gray,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth().contentWidth(maxWidth)
                    )
                }

                val dayOfWeekLabelsRes = listOf(
                    Res.string.day_monday,
                    Res.string.day_tuesday,
                    Res.string.day_wednesday,
                    Res.string.day_thursday,
                    Res.string.day_friday,
                    Res.string.day_saturday,
                    Res.string.day_sunday
                )
                val dayOrder = (0..6).map { (it + state.firstDayOfWeek - 1) % 7 + 1 }

                // The same grid and day form in both layouts; phones keep them stacked.
                val calendar: @Composable (Modifier, PaddingValues) -> Unit = { gridModifier, gridPadding ->
                    LazyVerticalGrid(
                        columns = GridCells.Fixed(7),
                        contentPadding = gridPadding,
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalArrangement = Arrangement.spacedBy(4.dp),
                        modifier = gridModifier
                    ) {
                        // Day of week labels based on firstDayOfWeek
                        items(dayOrder) { isoDayNum ->
                            Text(
                                text = stringResource(dayOfWeekLabelsRes[isoDayNum - 1]).take(3),
                                style = MaterialTheme.typography.labelSmall,
                                textAlign = TextAlign.Center,
                                color = Color.Gray
                            )
                        }

                        // Padding for the first week
                        if (daysInMonth.isNotEmpty()) {
                            val firstDayOfMonth = daysInMonth.first()
                            val firstDayIsoNum = firstDayOfMonth.dayOfWeek.isoDayNumber

                            // Calculate offset: how many empty cells before the 1st
                            val offset = (firstDayIsoNum - state.firstDayOfWeek + 7) % 7

                            items(offset) {
                                Box(Modifier.size(40.dp))
                            }
                        }

                        // Calendar Days
                        items(daysInMonth) { date ->
                            val dayNum = date.day
                            val pref = state.days[dayNum]
                            val isSelected = state.selectedDay == dayNum

                            CalendarDayCircle(
                                day = dayNum,
                                status = pref?.status ?: AvailabilityStatus.AVAILABLE,
                                isSelected = isSelected,
                                outsideRequest = !state.isRequested(dayNum),
                                isPicked = dayNum in state.multiSelected,
                                onLongClick = if (state.isReadOnly) null else {
                                    { viewModel.onEvent(AvailabilityFormEvent.ToggleMultiSelect(dayNum)) }
                                },
                                onClick = {
                                    // SH-165: while picking several days, a tap picks one more.
                                    if (state.multiSelected.isNotEmpty()) viewModel.onEvent(AvailabilityFormEvent.ToggleMultiSelect(dayNum))
                                    else viewModel.onEvent(AvailabilityFormEvent.SelectDay(dayNum))
                                }
                            )
                        }
                    }
                }
                fun dateOf(day: Int?): LocalDate? = if (day != null && state.monthIso.isNotBlank()) {
                    val parts = state.monthIso.split("-")
                    LocalDate(parts[0].toInt(), parts[1].toInt(), day)
                } else null
                val selectedDate = dateOf(state.selectedDay)
                // SH-158: picking another day fades its form in (the old day's fades out); each
                // form shows its own day, also while it leaves.
                val dayForm: @Composable (Boolean) -> Unit = { asPanel ->
                    MotionContent(state.selectedDay, Modifier.fillMaxWidth(), label = "availabilityDay") { shownDay ->
                        dateOf(shownDay)?.let { date ->
                            val selectedDay = shownDay!!
                            DayPreferenceForm(
                                date = date,
                                preference = state.days[selectedDay] ?: DayPreference(
                                    AvailabilityStatus.AVAILABLE,
                                    null,
                                    null
                                ),
                                availableSlots = state.availableSlots,
                                isReadOnly = state.isReadOnly,
                                asPanel = asPanel,
                                commentOnlyHere = selectedDay in state.commentOnlyHere,
                                offerCommentScope = state.hasOtherWorkplaces,
                                onHoursChanged = { hours ->
                                    if (!state.isReadOnly) viewModel.onEvent(AvailabilityFormEvent.SetDayHours(selectedDay, hours))
                                },
                                onCommentScopeChanged = { onlyHere ->
                                    if (!state.isReadOnly) viewModel.onEvent(AvailabilityFormEvent.SetCommentOnlyHere(selectedDay, onlyHere))
                                },
                                onPreferenceChanged = {
                                    if (!state.isReadOnly) {
                                        viewModel.onEvent(
                                            AvailabilityFormEvent.UpdateDayPreference(
                                                selectedDay,
                                                it
                                            )
                                        )
                                    }
                                }
                            )
                        }
                    }
                }

                if (isExpanded) {
                    // Wide windows: the month on the left, the chosen day beside it instead of
                    // a sheet-like card under the calendar.
                    // The calendar takes the left margin, the day the right one; their shares of
                    // the centred width stay 55:45.
                    val inner = (this@CentredBox.maxWidth - margin * 2 - 56.dp).coerceAtLeast(0.dp).value
                    Row(
                        modifier = Modifier.weight(1f).fillMaxWidth().padding(vertical = 16.dp),
                        horizontalArrangement = Arrangement.spacedBy(24.dp)
                    ) {
                        calendar(
                            Modifier.weight(0.55f * inner + margin.value + 16f).fillMaxHeight(),
                            PaddingValues(start = margin + 32.dp, end = 16.dp, top = 16.dp, bottom = 16.dp)
                        )
                        Box(Modifier.weight(0.45f * inner + margin.value + 16f).fillMaxHeight().padding(end = margin + 16.dp)) {
                            if (selectedDate != null) {
                                dayForm(true)
                            } else {
                                Text(
                                    stringResource(Res.string.availability_pick_day_hint),
                                    style = MaterialTheme.typography.bodyMedium,
                                    color = DeepNavy.copy(alpha = 0.6f),
                                    textAlign = TextAlign.Center,
                                    modifier = Modifier.align(Alignment.Center).padding(24.dp)
                                )
                            }
                        }
                    }
                } else {
                    calendar(Modifier.weight(1f), PaddingValues(16.dp).plusHorizontal(margin))

                    // --- Selected Day Form ---
                    Box(Modifier.fillMaxWidth().contentWidth(maxWidth)) { dayForm(false) }
                }
            }
            }
        }
    }

    if (state.showApplyDialog) {
        ApplyTemplateDialog(
            templates = state.availableTemplates,
            weeks = state.monthWeeks,
            onDismiss = { viewModel.onEvent(AvailabilityFormEvent.CloseApplyDialog) },
            onConfirm = { templateId, weeks ->
                viewModel.onEvent(AvailabilityFormEvent.ApplyTemplateToWeeks(templateId, weeks))
            }
        )
    }
}

@Composable
fun ApplyTemplateDialog(
    templates: List<WeeklyAvailabilityTemplate>,
    weeks: List<MonthWeek>,
    onDismiss: () -> Unit,
    onConfirm: (String, Set<Int>) -> Unit
) {
    var selectedTemplateId by remember { mutableStateOf(templates.firstOrNull()?.id ?: "") }
    var selectedWeeks by remember { mutableStateOf(weeks.map { it.weekNumber }.toSet()) }

    EvoDialog(
        title = stringResource(Res.string.availability_apply_week_template),
        icon = Icons.Default.ContentCopy,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(24.dp),
        confirm = DialogAction(
            stringResource(Res.string.apply),
            { onConfirm(selectedTemplateId, selectedWeeks) },
            enabled = selectedTemplateId.isNotBlank() && selectedWeeks.isNotEmpty()
        )
    ) {
        DialogSection(stringResource(Res.string.availability_select_template)) {
            EvoRadioGroup(
                options = templates.map { it.id },
                selected = selectedTemplateId,
                onSelect = { selectedTemplateId = it },
                optionLabel = { id -> templates.first { it.id == id }.name }
            )
        }
        DialogSection(stringResource(Res.string.availability_select_weeks)) {
            Column {
                weeks.forEach { week ->
                    EvoCheckboxRow(
                        checked = week.weekNumber in selectedWeeks,
                        onCheckedChange = { checked ->
                            selectedWeeks = if (checked) selectedWeeks + week.weekNumber else selectedWeeks - week.weekNumber
                        },
                        label = stringResource(
                            Res.string.availability_week,
                            week.weekNumber,
                            "${week.startDate.day}.${week.startDate.month.number}",
                            "${week.endDate.day}.${week.endDate.month.number}"
                        )
                    )
                }
            }
        }
    }
}

@Composable
fun ActionChip(
    icon: ImageVector,
    label: String,
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .border(0.5.dp, DeepNavy.copy(alpha = 0.3f), RoundedCornerShape(16.dp))
            .clip(RoundedCornerShape(16.dp))
            .handCursor()
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 6.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Icon(icon, null, modifier = Modifier.size(14.dp), tint = DeepNavy)
        Text(label, fontSize = 11.sp, color = DeepNavy, fontWeight = FontWeight.Medium)
    }
}

/** SH-165: the circles' colours, shared with the legend. */
private val AvailableGreen = Color(0xFF2E7D32)
private val UnavailableRed = Color(0xFFC62828)

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun CalendarDayCircle(
    day: Int,
    status: AvailabilityStatus,
    isSelected: Boolean,
    /** Outside the days the manager asked about (SH-48): shown faded, still editable. */
    outsideRequest: Boolean = false,
    /** SH-165: picked for a change of several days at once. */
    isPicked: Boolean = false,
    onLongClick: (() -> Unit)? = null,
    onClick: () -> Unit
) {
    // SH-158: a day turning available / unavailable / selected changes colour smoothly.
    val bgColor by animateColorAsState(
        when {
            isSelected && !isPicked -> DeepNavy
            outsideRequest -> Color.LightGray
            status == AvailabilityStatus.AVAILABLE -> AvailableGreen
            else -> UnavailableRed
        },
        motionTween(),
        label = "dayCircle"
    )
    // SH-165: not by colour alone: a tick or a cross with the number, and said aloud.
    val available = status == AvailabilityStatus.AVAILABLE
    val label = stringResource(if (available) Res.string.availability_day_available_mark else Res.string.availability_day_unavailable_mark, day)

    Box(
        modifier = Modifier
            // SH-163: a 48 dp target around the same 40 dp circle.
            .minimumInteractiveComponentSize()
            .size(40.dp)
            .clip(CircleShape)
            .background(bgColor)
            .border(
                when {
                    isPicked -> 3.dp
                    isSelected -> 2.dp
                    else -> 0.dp
                },
                if (isPicked) DeepNavy else DarkGold, CircleShape
            )
            .handCursor()
            .combinedClickable(onClick = onClick, onLongClick = onLongClick)
            .semantics(mergeDescendants = true) {
                contentDescription = label
                selected = isPicked || isSelected
            }
            .testTag(AvailabilityFormTags.day(day)),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
            Text(
                text = day.toString(),
                color = Color.White,
                fontWeight = FontWeight.Bold,
                fontSize = 13.sp,
                lineHeight = 13.sp
            )
            // An icon, not text: the day's text stays its number (and the description says the rest).
            Icon(
                if (available) Icons.Default.Check else Icons.Default.Close,
                contentDescription = null,
                tint = Color.White,
                modifier = Modifier.size(10.dp)
            )
        }
    }
}

/** SH-165: what the circles mean, under the calendar's header. */
@Composable
internal fun AvailabilityLegend(showOutside: Boolean, modifier: Modifier = Modifier) {
    @Composable
    fun item(color: Color, mark: String, text: String) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(4.dp)) {
            Box(Modifier.size(16.dp).clip(CircleShape).background(color), contentAlignment = Alignment.Center) {
                when (mark) {
                    "✓" -> Icon(Icons.Default.Check, contentDescription = null, tint = Color.White, modifier = Modifier.size(10.dp))
                    "✕" -> Icon(Icons.Default.Close, contentDescription = null, tint = Color.White, modifier = Modifier.size(10.dp))
                }
            }
            Text(text, style = MaterialTheme.typography.labelSmall, color = DeepNavy)
        }
    }
    Row(
        modifier = modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 6.dp).testTag(AvailabilityFormTags.LEGEND),
        horizontalArrangement = Arrangement.spacedBy(16.dp, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {
        item(AvailableGreen, "✓", stringResource(Res.string.availability_available))
        item(UnavailableRed, "✕", stringResource(Res.string.availability_unavailable))
        if (showOutside) item(Color.LightGray, "", stringResource(Res.string.availability_legend_outside))
    }
}

/** SH-165: several days picked by a long press: set them all, or stop picking. */
@Composable
private fun MultiSelectBar(count: Int, onSet: (AvailabilityStatus) -> Unit, onCancel: () -> Unit, modifier: Modifier = Modifier) {
    Row(
        modifier = modifier.fillMaxWidth().background(DeepNavy).padding(horizontal = 16.dp, vertical = 8.dp).testTag(AvailabilityFormTags.MULTI_BAR),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            stringResource(Res.string.availability_selected_days, count),
            color = Color.White,
            fontWeight = FontWeight.Bold,
            style = MaterialTheme.typography.bodyMedium,
            modifier = Modifier.weight(1f)
        )
        TextButton(onClick = { onSet(AvailabilityStatus.AVAILABLE) }, modifier = Modifier.handCursor()) {
            Text(stringResource(Res.string.availability_available), color = Color(0xFFA5D6A7), fontWeight = FontWeight.Bold)
        }
        TextButton(onClick = { onSet(AvailabilityStatus.UNAVAILABLE) }, modifier = Modifier.handCursor()) {
            Text(stringResource(Res.string.availability_unavailable), color = Color(0xFFEF9A9A), fontWeight = FontWeight.Bold)
        }
        IconButtonWithTooltip(onClick = onCancel, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.cancel)) {
            Icon(Icons.Default.Close, stringResource(Res.string.cancel), tint = Color.White)
        }
    }
}

@Composable
fun DayPreferenceForm(
    date: LocalDate,
    preference: DayPreference,
    availableSlots: List<AvailabilitySlot>,
    isReadOnly: Boolean,
    asPanel: Boolean = false,
    commentOnlyHere: Boolean = false,
    offerCommentScope: Boolean = false,
    /**
     * SH-173: inside a page that scrolls itself (the e-mailed link's form, sent with a button):
     * no own scrolling and no "saved automatically" note.
     */
    embedded: Boolean = false,
    onHoursChanged: (HoursRange?) -> Unit = {},
    onCommentScopeChanged: (Boolean) -> Unit = {},
    onPreferenceChanged: (DayPreference) -> Unit
) {
    // Under the calendar on phones (a sheet-like card); a side panel next to it on wide windows.
    Card(
        modifier = if (asPanel) Modifier.fillMaxWidth() else Modifier.fillMaxWidth().height(320.dp),
        shape = if (asPanel) RoundedCornerShape(24.dp) else RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 8.dp)
    ) {
        val autoSaveText = stringResource(Res.string.availability_auto_saving)
        val unavailableText = stringResource(Res.string.availability_unavailable)
        val availableText = stringResource(Res.string.availability_available)

        Column(
            modifier = Modifier.padding(24.dp).then(if (embedded) Modifier else Modifier.verticalScroll(rememberScrollState())),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            // Header "Środa, 14 marca"; the auto-save note sits under it so the two never overlap.
            Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(
                    text = dayAndDate(date),
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                if (!isReadOnly && !embedded) {
                    Text(
                        text = autoSaveText,
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Gray
                    )
                }
            }

            // Unavailable / Available Toggle
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(44.dp)
                    .clip(RoundedCornerShape(12.dp))
                    .border(1.dp, DeepNavy.copy(alpha = 0.1f), RoundedCornerShape(12.dp))
            ) {
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                        .background(
                            if (preference.status == AvailabilityStatus.UNAVAILABLE) Color(
                                0xFFD32F2F
                            ) else Color.Transparent
                        )
                        .handCursor()
                        .clickable(enabled = !isReadOnly) {
                            onPreferenceChanged(
                                preference.copy(
                                    status = AvailabilityStatus.UNAVAILABLE
                                )
                            )
                        },
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        unavailableText,
                        color = if (preference.status == AvailabilityStatus.UNAVAILABLE) Color.White else Color.Red,
                        fontWeight = FontWeight.Bold,
                        fontSize = 14.sp
                    )
                }
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                        .background(
                            if (preference.status == AvailabilityStatus.AVAILABLE) Color(
                                0xFF4CAF50
                            ) else Color.Transparent
                        )
                        .handCursor()
                        .clickable(enabled = !isReadOnly) {
                            onPreferenceChanged(
                                preference.copy(
                                    status = AvailabilityStatus.AVAILABLE
                                )
                            )
                        },
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        availableText,
                        color = if (preference.status == AvailabilityStatus.AVAILABLE) Color.White else Color(
                            0xFF4CAF50
                        ),
                        fontWeight = FontWeight.Bold,
                        fontSize = 14.sp
                    )
                }
            }

            if (preference.status == AvailabilityStatus.AVAILABLE) {
                // Select Preferred Shifts
                Text(
                    stringResource(Res.string.availability_select_preferred_shifts),
                    style = MaterialTheme.typography.labelMedium,
                    fontWeight = FontWeight.Bold
                )

                ScrollingRow(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    availableSlots.forEach { slot ->
                        val isSelected = preference.preferredSlotId == slot.id
                        Box(
                            modifier = Modifier
                                .border(
                                    width = 1.dp,
                                    color = if (isSelected) DeepNavy else Color.Gray.copy(alpha = 0.3f),
                                    shape = RoundedCornerShape(16.dp)
                                )
                                .clip(RoundedCornerShape(16.dp))
                                .background(if (isSelected) DeepNavy.copy(alpha = 0.1f) else Color.Transparent)
                                .handCursor()
                                .clickable(enabled = !isReadOnly) {
                                    onPreferenceChanged(
                                        preference.copy(
                                            preferredSlotId = if (isSelected) null else slot.id
                                        )
                                    )
                                }
                                .padding(horizontal = 12.dp, vertical = 8.dp)
                        ) {
                            Text(
                                text = "${slot.label} (${slot.startTime}-${slot.endTime})",
                                fontSize = 12.sp,
                                color = DeepNavy
                            )
                        }
                    }
                }

                // SH-135: the hours they can work (empty: the whole day), shared by every workplace.
                DayHoursFields(
                    hours = preference.hours.firstOrNull(),
                    isReadOnly = isReadOnly,
                    dayKey = date.toString(),
                    onHoursChanged = onHoursChanged
                )

                // Add note
                rememberStableText(preference.comment ?: "", { onPreferenceChanged(preference.copy(comment = it)) }).let { stable ->
                    OutlinedTextField(
                        value = stable.value,
                        onValueChange = stable.onValueChange,
                        placeholder = { Text(stringResource(Res.string.availability_add_note_placeholder)) },
                        modifier = Modifier.fillMaxWidth(),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedBorderColor = DeepNavy,
                            unfocusedBorderColor = DeepNavy.copy(alpha = 0.1f)
                        ),
                        enabled = !isReadOnly
                    )
                }
                if (offerCommentScope) {
                    EvoCheckboxRow(
                        label = stringResource(Res.string.availability_comment_only_here),
                        checked = commentOnlyHere,
                        onCheckedChange = { onCommentScopeChanged(it) },
                        enabled = !isReadOnly
                    )
                }
            }
        }
    }
}

/** Test tags of the availability form (SH-135). */
object AvailabilityFormTags {
    const val SHARED_NOTE = "availability_shared_note"
    const val HOURS_FROM = "availability_hours_from"
    const val HOURS_TO = "availability_hours_to"
    const val LEGEND = "availability_legend"
    const val MULTI_BAR = "availability_multi_bar"
    fun day(day: Int) = "availability_day_$day"
}

/**
 * SH-135: "From" and "To" of the hours the person can work that day, "HH:MM". Both valid: saved;
 * both empty: the whole day. Typing in between keeps what was saved. SH-165: time fields that say
 * what is wrong (a time that is not one, one of the two missing, an end before the start).
 */
@Composable
private fun DayHoursFields(hours: HoursRange?, isReadOnly: Boolean, dayKey: String, onHoursChanged: (HoursRange?) -> Unit) {
    var from by remember(dayKey) { mutableStateOf(hours?.start.orEmpty()) }
    var to by remember(dayKey) { mutableStateOf(hours?.end.orEmpty()) }
    // "8" and "800" read as 08:00 like elsewhere; "24:00" is the end of the day.
    fun normalised(text: String): String? = text.trim().let { t -> parseClockTime(t) ?: t.takeIf { HoursRange.minutesOf(it) != null } }
    val fromTime = normalised(from)
    val toTime = normalised(to)
    val incomplete = (from.isBlank()) != (to.isBlank())
    val wrongOrder = fromTime != null && toTime != null && HoursRange(fromTime, toTime).minutes == null
    fun changed() {
        val f = normalised(from)
        val t = normalised(to)
        when {
            from.isBlank() && to.isBlank() -> onHoursChanged(null)
            f != null && t != null && HoursRange(f, t).minutes != null -> onHoursChanged(HoursRange(f, t))
        }
    }
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(stringResource(Res.string.availability_hours_title), style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.Bold)
        if (isReadOnly) {
            Text(
                if (hours == null) stringResource(Res.string.availability_hours_hint) else "${hours.start}–${hours.end}",
                style = MaterialTheme.typography.bodyMedium,
                color = DeepNavy
            )
            return@Column
        }
        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            EvoTimeField(
                value = from,
                onValueChange = { from = it; changed() },
                label = stringResource(Res.string.availability_hours_from),
                optional = true,
                isValid = { normalised(it) != null },
                onLight = true,
                error = stringResource(Res.string.availability_hours_incomplete).takeIf { incomplete && from.isBlank() },
                modifier = Modifier.weight(1f).testTag(AvailabilityFormTags.HOURS_FROM)
            )
            EvoTimeField(
                value = to,
                onValueChange = { to = it; changed() },
                label = stringResource(Res.string.availability_hours_to),
                placeholder = "16:00",
                optional = true,
                isValid = { normalised(it) != null },
                onLight = true,
                error = when {
                    incomplete && to.isBlank() -> stringResource(Res.string.availability_hours_incomplete)
                    wrongOrder -> stringResource(Res.string.availability_hours_order)
                    else -> null
                },
                imeAction = ImeAction.Done,
                modifier = Modifier.weight(1f).testTag(AvailabilityFormTags.HOURS_TO)
            )
        }
        Text(stringResource(Res.string.availability_hours_hint), style = MaterialTheme.typography.bodySmall, color = Color.Gray)
    }
}
